// ============================================================================
// GESTIMMONY — Gating des offres côté frontend
// ============================================================================
// Dérive le contexte de formule (plafonds, droits d'écriture, accès IA) à
// partir de l'utilisateur renvoyé par /auth/me, et centralise l'affichage des
// erreurs de gating renvoyées par le backend (403 { code, message, cta }).
// ============================================================================
import { toast } from "sonner";

export const PLAN_LIMITS = {
  essentiel: { properties: 3, letters: 8, ai: false, label: "Essentiel" },
  patrimoine: { properties: 10, letters: 16, ai: true, label: "Patrimoine" },
  prestige: { properties: 20, letters: 20, ai: true, label: "Prestige" },
};

const ACTIVE_STATUSES = ["active", "trialing"];

export function planTier(user) {
  const plan = (user?.subscription_plan || "").toLowerCase();
  for (const tier of ["essentiel", "patrimoine", "prestige"]) {
    if (plan.includes(tier)) return tier;
  }
  return null;
}

// Renvoie le contexte de formule applicable à l'utilisateur.
export function planContext(user) {
  const isAdmin = user?.role === "admin";
  const isDemo = !!user?.is_demo;
  const isMember = !!user?.is_member;
  const tier = planTier(user);
  const limits = PLAN_LIMITS[tier || "essentiel"];
  const active = ACTIVE_STATUSES.includes(user?.subscription_status);
  // Démo ET collaborateur SCI : strictement en lecture seule (aucune écriture).
  const canWrite = !isDemo && !isMember && (isAdmin || active);
  const hasAI = isAdmin || (active && limits.ai);
  return { isAdmin, isDemo, isMember, tier, limits, active, canWrite, hasAI };
}

// Intercepte une erreur de gating backend et affiche un toast avec bouton vers
// la page Abonnement. Renvoie true si l'erreur a été gérée, false sinon.
export function handleGateError(err, navigate) {
  const detail = err?.response?.data?.detail;
  if (err?.response?.status === 403 && detail && typeof detail === "object" && detail.code) {
    toast.error(detail.message || "Action non autorisée", {
      duration: 8000,
      action: {
        label: "Voir les offres",
        onClick: () => navigate(detail.cta || "/app/abonnement"),
      },
    });
    return true;
  }
  return false;
}
